module.exports = __webpack_public_path__ + "static/media/sharon.a3e9a6d8.jpg";